import React from 'react'

/**
 * Renders the small amount of inline markdown portal texts may contain:
 * **bold** and [label](https://example.com).
 *
 * Deliberately not a markdown library and deliberately not HTML. Everything is
 * returned as React nodes, so text an administrator typed is escaped by React
 * like any other string and can never become markup. An editor who writes
 * `<script>` sees `<script>` on the page.
 */

// Only absolute http(s) links and paths inside the portal. Anything else —
// javascript:, data:, mailto: — renders as plain text rather than a link.
const SAFE_LINK = /^(https?:\/\/|\/)/i

const TOKEN = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)\s]+\))/g

export function renderInline(text, keyPrefix = 'md') {
  if (text == null) return null
  const parts = String(text).split(TOKEN)
  return parts.map((part, i) => {
    if (!part) return null
    const key = `${keyPrefix}-${i}`

    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={key}>{part.slice(2, -2)}</strong>
    }

    const link = /^\[([^\]]+)\]\(([^)\s]+)\)$/.exec(part)
    if (link) {
      const [, label, href] = link
      if (!SAFE_LINK.test(href)) return <React.Fragment key={key}>{part}</React.Fragment>
      const external = /^https?:\/\//i.test(href)
      return (
        <a
          key={key}
          href={href}
          {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        >
          {label}
        </a>
      )
    }

    return <React.Fragment key={key}>{part}</React.Fragment>
  })
}

/** Substitutes {name} from vars. A missing value stays visible as {name}. */
export function interpolate(text, vars) {
  if (text == null) return ''
  if (!vars) return String(text)
  return String(text).replace(/\{(\w+)\}/g, (whole, name) =>
    Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : whole,
  )
}
